import React from 'react'
import { FaChevronCircleLeft } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'

import logo from '../../assets/logo.png'

interface Props {
  title?: string
  to: string
  onBack?: () => void // ✅ optional custom back handler
}

const Header1: React.FC<Props> = ({ title, to, onBack }) => {
  const navigate = useNavigate()

  const handleBack = (): void => {
    if (onBack) {
      onBack()
    } else {
      navigate(to)
    }
  }

  return (
    <div className="sticky z-50 w-full top-0 left-0 flex flex-col justify-around h-[80px] bg-[#3C486B] pt-4 px-5">
      <div className="flex flex-row justify-between lg:justify-around items-center">
        {/* Back chevron button */}
        <button onClick={handleBack}>
          <FaChevronCircleLeft size={25} color="white" />     {/* Previously it was Link,Changed Link to Button */}
        </button>

        {/* Title */}
        <div>
          <p className="text-xl text-white">{title}</p>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center">
          <div className="flex flex-col">
            <Link to="/">
              <img className="h-10 w-10" alt="TGE" src={logo} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header1



// import React from 'react'
// import { FaChevronCircleLeft } from 'react-icons/fa'
// import { Link } from 'react-router-dom'

// import logo from '../../assets/logo.png'
// interface Props {
//   title?: string
//   to: string
// }
// const Header1: React.FC<Props> = ({ title, to }) => {
//   return (
//     <div className=' flex flex-col justify-around h-[80px] bg-[#3C486B] pt-4 px-5'>
//       <div className='flex flex-row justify-between lg:justify-around items-center'>
//         <Link to={to}>
//           <FaChevronCircleLeft size={25} color='white' />
//         </Link>
//         <div>
//         <p className='text-xl text-white'>{title}</p>
//         </div>
//         <div className=" flex items-center justify-center">
//           <div className='flex flex-col'>
//             <Link to="/">
//               <img className="h-10 w-10" alt='TGE' src={logo} />
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Header1
